import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import InputSelect from './InputSelect'
import UploadDesign from './UploadDesign'
import { getListBrands, createTagBrand } from '../../../services/api/apiBrands'
import { Spin, message } from 'antd'
import getHistory from "../../../getHistory"


const BRAND_TYPE = [
    {
        label: 'Branding',
        value: 'branding'
    },
    {
        label: 'Packaging ',
        value: 'packaging'
    }
]

const TagBrandNewPage = () => {

    const [brandName, setBrandName] = useState('')
    const [brandType, setBrandType] = useState('')
    const [materialCode, setMaterialCode] = useState('')
    const [brandDetail, setBrandDetail] = useState('')
    const [fileUpload, setFileUpload] = useState('')
    const [description, setDescription] = useState('')
    const [note, setNote] = useState('')
    const [quantity, setQuantity] = useState('')
    const [baseCost, setBaseCost] = useState('')
    const [fullFee, setFullFee] = useState('')
    const [errors, setErrors] = useState('')
    const [loading, setLoading] = useState('')
    const [errBrand, setErrBrand] = useState('')
    const [listBrands, setListBrands] = useState([])

    const _handleChangeBrandType = type => {
        setBrandType(type)
        delete errors.brandType
    }

    const _handleChangeBrandName = name => {
        setBrandName(name)
        delete errors.brandName
    }

    const _handleChangeMaterialCode = code => {
        setMaterialCode(code)
        delete errors.materialCode
    }

    const _handleChangeBrandDetail = detail => {
        setBrandDetail(detail)
        delete errors.brandDetail
    }

    const _handleChangeFileUpload = file => {
        setFileUpload(file)
    }

    const _handleRemovePreview = () => {
        setFileUpload('')
    }

    const _handleChangeDescription = description => {
        setDescription(description)
    }

    const _handleChangeNote = text => {
        setNote(text)
    }

    const _handleChangeQuantity = quantity => {
        const rx_live = /^[+-]?\d*(?:\d*)?$/
        if (rx_live.test(quantity)) {
            setQuantity(quantity)
            delete errors.quantity
        }
    }

    const _handleChangeBaseCost = cost => {
        const rx_live = /^[+]?\d*(?:[.,]\d{0,4})?$/
        if (rx_live.test(cost)) {
            setBaseCost(cost)
            delete errors.baseCost
        }
    }

    const _handleChangeFullFee = cost => {
        const rx_live = /^[+]?\d*(?:[.,]\d{0,4})?$/
        if (rx_live.test(cost)) {
            setFullFee(cost)
            delete errors.fullFee
        }
    }

    const _fetchListBrands = async () => {
        try {
            const { data, message, success } = await getListBrands({ limit: 1000 })
            const { Brands } = data
            if (!success) return setErrBrand(message)

            const ListBrands = Brands.filter(brand => brand.is_active).map(item => ({
                value: item._id,
                label: item.name
            }))

            setListBrands(ListBrands)
        } catch (e) {
            throw new Error(e.message)
        }
    }

    useEffect(() => {
        _fetchListBrands()
    }, [])

    const _validate = () => {
        let err = {}

        if (!brandName) err.brandName = 'Brand is required!'
        if (!brandType) err.brandType = 'Brand type is required!'
        if (!materialCode) err.materialCode = 'Material code is required!'
        if (!brandDetail) err.brandDetail = 'Brand detail is required!'
        if (!quantity) err.quantity = 'Quantity is required!'

        setErrors(err)

        if (Object.keys(err).length > 0) return false

        return true

    }

    const handleSave = async () => {
        const isValidate = _validate()

        if (!isValidate) return

        setLoading(true)
        setErrors('')

        try {
            const payload = {
                brand: brandName,
                type: brandType,
                name: brandDetail.trim(),
                quantity: +quantity,
                base_cost: +baseCost,
                fee: +fullFee,
                is_active: true,
                material_code: materialCode.trim(),
            }
            const formData = new FormData()

            Object.keys(payload).forEach(key => formData.append(key, payload[key]))
            if (fileUpload) formData.append('file', fileUpload)
            if (note) formData.append('note', note.trim())
            if (description) formData.append('description', description.trim())

            const { data } = await createTagBrand(formData)
            const { success, message: mess } = data

            if (!success) return message.error(mess)

            setBrandName('')
            setBrandType('')
            setMaterialCode('')
            setBrandDetail('')
            setFileUpload('')
            setDescription('')
            setNote('')
            setQuantity('')
            setBaseCost('')
            setFullFee('')

            const history = getHistory()
            history.push(`/tag-brands`)
            message.success("Create tag brand success!")

        } catch (e) {
            throw new Error(e.message)
        } finally {
            setLoading(false)
        }

    }

    return (
        <div className='TagBrandNewPage'>
            <div className="ReturnPage mb-2">
                <Link to={'/tag-brands'} className="txt-16">
                    <i className="fa fa-chevron-left mr-2" /> List tag brands inventory
                </Link>
            </div>
            <div className="TagBrandForm">
                <div className='PageHeading d-flex align-items-center justify-content-between border-bottom'>
                    <h1 className="PageTitle font-weight-bold mb-0">Add news tag brands</h1>
                    <div className="RightTop">
                        <div className='Actions mb-2'>
                            <Link to={'/tag-brands'}>
                                <button
                                    className='btn btn-secondary mx-1 px-3'
                                    style={{ background: '#C4C4C4' }}
                                >
                                    Cancel
                                </button>
                            </Link>
                            <button
                                className='btn btn-primary mx-1 px-4'
                                style={{ background: '#4A80F7' }}
                                onClick={handleSave}
                                disabled={loading}
                            >
                                <Spin spinning={loading} size="small" className='mr-2' />Save
                            </button>
                        </div>
                    </div>
                </div>

                <div className="SectionInner card px-4 py-4 mt-3" style={{ minHeight: '80vh' }}>
                    <div className="row">
                        <div className="col-12 mb-3">
                            <InputSelect
                                title="Brand"
                                options={listBrands}
                                placeholder="---Choose brands---"
                                handleChangeBrandInput={_handleChangeBrandName}
                                type="select"
                                errors={errors}
                                keyErr="brandName"
                                errBrand={errBrand}
                                valueInput={brandName}
                            />
                        </div>
                        <div className="col-12 mb-3">
                            <InputSelect
                                title="Brand type"
                                options={BRAND_TYPE}
                                placeholder="---Choose brand type---"
                                handleChangeBrandInput={_handleChangeBrandType}
                                type="select"
                                errors={errors}
                                keyErr="brandType"
                                valueInput={brandType}
                            />
                        </div>
                        <div className="col-12 mb-3">
                            <InputSelect
                                title="Material code"
                                handleChangeBrandInput={_handleChangeMaterialCode}
                                valueInput={materialCode}
                                type="input"
                                errors={errors}
                                keyErr="materialCode"
                            />
                        </div>
                        <div className="col-12 mb-3">
                            <InputSelect
                                title="Brand Detail"
                                handleChangeBrandInput={_handleChangeBrandDetail}
                                valueInput={brandDetail}
                                type="input"
                                errors={errors}
                                keyErr="brandDetail"
                            />
                        </div>
                        <div className="col-12 mb-3">
                            <UploadDesign
                                handleChangeFileUpload={_handleChangeFileUpload}
                                handleChangeNote={_handleChangeNote}
                                handleChangeDescription={_handleChangeDescription}
                                note={note}
                                description={description}
                                fileUpload={fileUpload}
                                handleRemovePreview={_handleRemovePreview}
                            />
                        </div>
                        <div className="col-12 mb-3">
                            <InputSelect
                                title="Quantity"
                                handleChangeBrandInput={_handleChangeQuantity}
                                valueInput={quantity}
                                type="input"
                                errors={errors}
                                keyErr="quantity"
                            />
                        </div>
                        <div className="col-12 mb-3">
                            <InputSelect
                                title="Base cost"
                                handleChangeBrandInput={_handleChangeBaseCost}
                                valueInput={baseCost}
                                type="cost"
                                errors={errors}
                                keyErr="baseCost"
                            />
                        </div>
                        <div className="col-12">
                            <InputSelect
                                title="Fullfillment fee"
                                handleChangeBrandInput={_handleChangeFullFee}
                                valueInput={fullFee}
                                type="cost"
                                errors={errors}
                                keyErr="fullFee"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TagBrandNewPage